<script setup lang="ts">
/**
 * A still of the applications board (pages/applications.vue): three columns
 * with a few cards, one of them flagged for a follow-up. Shown on
 * /job-application-tracker and its homepage teaser. Illustration only —
 * every word comes from `trackerPage.mock`.
 */
const { t } = useI18n()

const columns = [
  { id: 'applied', dot: 'bg-blue-500', cards: [{ id: 'a', followUp: true, letter: true }, { id: 'b', followUp: false, letter: false }] },
  { id: 'interview', dot: 'bg-amber-500', cards: [{ id: 'c', followUp: false, letter: true }] },
  { id: 'offer', dot: 'bg-accent', cards: [{ id: 'd', followUp: false, letter: true }] },
] as const
</script>

<template>
  <div class="rounded-[0.625rem] bg-white p-4 shadow-lift dark:bg-gray-800 sm:p-5" aria-hidden="true">
    <div class="grid grid-cols-3 gap-2.5">
      <div v-for="column in columns" :key="column.id" class="rounded-lg bg-surface p-2 dark:bg-gray-900">
        <div class="mb-2 flex items-center gap-1.5 px-1">
          <span class="size-2 rounded-full" :class="column.dot" />
          <span class="truncate font-title !text-xs font-bold !text-ink dark:!text-white">{{ t(`trackerPage.mock.columns.${column.id}`) }}</span>
        </div>
        <div class="space-y-2">
          <div v-for="card in column.cards" :key="card.id" class="rounded-md border border-line bg-white p-2 dark:border-gray-700 dark:bg-gray-800">
            <span class="block truncate font-title !text-xs font-bold !text-ink dark:!text-white">{{ t(`trackerPage.mock.cards.${card.id}.company`) }}</span>
            <span class="block truncate !text-[11px] !text-body dark:!text-gray-300">{{ t(`trackerPage.mock.cards.${card.id}.position`) }}</span>
            <span class="mt-1.5 flex items-center gap-1.5 !text-[10px] !text-muted dark:!text-gray-400">
              <i class="bi bi-file-earmark-text" />
              <i v-if="card.letter" class="bi bi-envelope-paper" />
            </span>
            <span v-if="card.followUp" class="mt-1.5 inline-flex items-center gap-1 rounded-full bg-amber-100 px-1.5 py-0.5 !text-[10px] font-semibold !text-amber-800">
              <i class="bi bi-bell" />{{ t('trackerPage.mock.followUp') }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
